<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2021-09-14 15:04:01
 * @LastEditors: mojiangpeng 125392435@qq.com
 * @LastEditTime: 2023-12-12 09:38:31
-->
<template>
  <div class="container">
    <head-nav-bar title="办理健康卡" :fixed="true" />
    <div class="mt-header-nav">
      <div class="listMenu">
        <router-link tag="div" class="list" to="/user/contact/addCard">
          <img class="iconImage" src="/images/write.png" />
          <div class="words">
            <p class="tittle">手填办卡</p>
            <p class="describe">在线办理电子就诊卡</p>
          </div>
        </router-link>
        <!-- <router-link tag="div" class="list" to="/user/contact/edit"> -->
        <div class="list" @click="toAddCard">
          <img class="iconImage" src="/images/bind.png" />
          <div class="words">
            <p class="tittle">在线绑卡</p>
            <p class="describe">可绑定已有就诊卡</p>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showSelectAddType"
      :showConfirmButton="false"
      :showCancelButton="true"
      title="请选择添加方式"
    >
      <div class="type-list">
        <div class="type-item" @click="onAddTypeClick(1)">
          按姓名+身份证号绑卡
        </div>
        <div class="type-item" @click="onAddTypeClick(2)">
          按姓名+就诊卡号绑卡
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Card, Dialog } from "vant"
export default {
  components: {
    [Card.name]: Card,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      info: {},
      showSelectAddType: false,
    }
  },
  created() {},
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "userContactCreatCardMenu",
        query: {
          Id: item.Id,
        },
      })
    },
    toAddCard() {
      this.showSelectAddType = true
    },
    onAddTypeClick(type) {
      this.$router.push({
        name: "userContactEdit",
        query: {
          type,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.mt-header-nav {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 10px;
}
.listMenu {
  width: 100%;

  .list {
    width: 100%;
    height: 80px;
    position: relative;
    background-color: #e6e6e6;
    border-radius: 10px;
    margin: 0 0 10px 0;
    font-size: 14px;
    .iconImage {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      width: 30px;
      height: 30px;
    }
    .words {
      position: absolute;
      top: 50%;
      left: 70px;
      transform: translateY(-50%);
      .tittle {
        color: #000;
        font-weight: bold;
      }
      .describe {
        color: #999;
      }
    }
  }
}

.type-list {
  font-size: 14px;
  padding: 20px;
  .type-item {
    padding: 20px;
    border: 1px solid #ddd;
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>
